import { render, staticRenderFns } from "./UserPasswordSuccess.vue?vue&type=template&id=aca0b3ec"
import script from "./UserPasswordSuccess.vue?vue&type=script&lang=js"
export * from "./UserPasswordSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports